import WinController from './winController';

export default class SmallWinController extends WinController {
  constructor(props) {
    super(props);
  }

  onStart() {
    if (this.ControllerPopup.stack.length) {
      this.setDurationOnNextCall(4000);
      this.setCounterOffsetOnNextCall(0);
    }
  }
}
